import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { TranslateService } from '@ngx-translate/core';

import { HttpBase } from 'app/services/http-base.service';


@Injectable()
export class SaveUserPropService extends HttpBase {
    constructor(http: HttpClient, router: Router, translateService: TranslateService) {
        super(http, router, translateService);
    }

    saveSlickGridProperties = (data: string): Observable<any> => {
        return this.post<any>('/api/slickgridproperties/savetableproperties', {data});
    }

    getSlickGridProperties = (moduleName: string, tableNames: string []): Observable<any> => {
        return this.get<any>('/api/slickgridproperties/getproperties', { params: { moduleName, tableNames }});
    }
}



// WEBPACK FOOTER //
// ./src/app/services/save-user-prop.ts